function trackEvent(eventName: string, params: Record<string, string | number>): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

export function trackBlogArticleView(
  articleSlug: string,
  articleTitle: string,
  articleSilo: string,
  readingMinutes: number,
): void {
  trackEvent('blog_article_view', {
    article_slug: articleSlug,
    article_title: articleTitle,
    article_silo: articleSilo,
    reading_minutes: readingMinutes,
  });
}

export function trackBlogScrollDepth(articleSlug: string, depthPercent: 25 | 50 | 75 | 100): void {
  trackEvent('blog_scroll_depth', {
    article_slug: articleSlug,
    depth_percent: depthPercent,
  });
}

export function trackBlogCtaClick(ctaLabel: string, articleSlug?: string): void {
  trackEvent('blog_cta_click', {
    cta_label: ctaLabel,
    ...(articleSlug ? { article_slug: articleSlug } : {}),
  });
}

export function trackBlogIndexView(siloFilter: string): void {
  trackEvent('blog_index_view', {
    silo_filter: siloFilter,
  });
}

export function trackBlogSiloView(siloId: string): void {
  trackEvent('blog_silo_view', {
    silo_id: siloId,
  });
}
